<template>
    <figure v-if="vendorId === 'tryg'" class="insurance-logo">
        <img
            v-if="type === 'small'"
            class="insurance-logo__img"
            src="~/assets/images/tryg-logo-small.png"
            :alt="companyName"
            width="140"
            height="60"
        />
        <img
            v-else
            class="insurance-logo__img"
            width="180"
            height="76"
            src="~/assets/images/tryg-logo.png"
            :alt="companyName"
        />
    </figure>
    <!-- eslint-disable-next-line vue/valid-template-root -->
    <figure v-else-if="vendorId === 'moderna'" class="insurance-logo">
        <img
            v-if="type === 'small'"
            class="insurance-logo__img"
            src="~/assets/images/moderna-logo-small.png"
            :alt="companyName"
            width="140"
            height="50"
        />
        <img
            v-else
            class="insurance-logo__img"
            width="180"
            height="66"
            src="~/assets/images/moderna-logo.png"
            :alt="companyName"
        />
    </figure>
    <figure v-else-if="isOmocomVendor" class="insurance-logo">
        <img
            v-if="type === 'small'"
            class="insurance-logo__img"
            src="~/assets/images/omocom-logo-small.png"
            :alt="companyName"
            width="140"
            height="44"
        />
        <img
            v-else
            class="insurance-logo__img"
            width="180"
            height="57"
            src="~/assets/images/omocom-logo.png"
            :alt="companyName"
        />
    </figure>
    <figure v-else-if="vendorId === BALOISE_ID" class="insurance-logo">
        <img
            class="insurance-logo__img"
            width="180"
            height="57"
            src="~/assets/images/baloise-logo.svg"
            :alt="companyName"
        />
    </figure>
</template>

<script>
import { OMOCOM_VENDOR_IDS, OMOCOM_SE_ID, OMOCOM_NO_ID, OMOCOM_FI_ID, BALOISE_ID } from '~/config/insurance';

export default {
    props: {
        type: {
            type: String,
            default: null,
        },
        country: {
            type: String,
            default: null,
        },
        vendor: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            BALOISE_ID,
        };
    },
    computed: {
        countryWithFallback() {
            return this.country || this.$store.getters.siteCountryCode;
        },
        defaultVendorId() {
            switch (this.$store.getters.siteCountryCode) {
                case 'FI':
                    return OMOCOM_FI_ID;
                case 'NO':
                    return OMOCOM_NO_ID;
                case 'CH':
                    return BALOISE_ID;
                default:
                    // SE and global
                    return OMOCOM_SE_ID;
            }
        },
        vendorId() {
            if (this.vendor) {
                return this.vendor.id;
            }

            return this.defaultVendorId;
        },
        isOmocomVendor() {
            return OMOCOM_VENDOR_IDS.includes(this.vendorId);
        },
        companyName() {
            if (this.vendor) {
                return this.vendor.name;
            }

            if (this.isOmocomVendor) {
                return 'Omocom';
            }

            if (this.vendorId === BALOISE_ID) {
                return 'Baloise';
            }

            switch (this.countryWithFallback) {
                case 'NO':
                    return 'Tryg Forsikring';
                case 'SE':
                default:
                    return 'Moderna Försäkringar';
            }
        },
    },
};
</script>

<style lang="scss">
.insurance-logo {
    display: inline-block;

    &__img {
        width: inherit;
        height: inherit;
    }
}
</style>
